import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import cx from 'classnames';
import styles from './DealerLocatorNonInstantAccessWarning.module.scss';

export interface DealerLocatorNonInstantAccessWarningProps {
  children: string;
}

export const DealerLocatorNonInstantAccessWarning = ({
  children
}: DealerLocatorNonInstantAccessWarningProps) => {
  return (
    <div className={styles['mainContainer']}>
      <CatIconWarningTriangle color="error" size="lg" />
      <p
        className={cx(
          'cat-u-theme-typography-label-sm m-0 ms-2',
          styles['wording']
        )}
      >
        {children}
      </p>
    </div>
  );
};
